<template>
  <form class="account__form-wrap">
    <IgnoredIPAddresses />
    <div class="account__form-section-wrap">
      <AccountKeys /><URLHijackingProtection />
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";

import IgnoredIPAddresses from "./advanced/IgnoredIPAddresses";
import AccountKeys from "./advanced/AccountKeys";
import URLHijackingProtection from "./advanced/URLHijackingProtection";

export default {
  name: "AdvancedSettings",
  components: { IgnoredIPAddresses, AccountKeys, URLHijackingProtection },
};
</script>

<style></style>
